<template>
  <div class="bulk-ingestion-progress-state">
    <span :class="`bulk-ingestion-progress-state__color-dot bulk-ingestion-progress-state__color-dot--${status}`" />
    <span v-tooltip="{ content: statusTooltipDesc, placement: 'top-start', html: true }" :class="textClass">{{ statusText }}</span>
  </div>
</template>

<script>
import i18n from 'src/assets/i18n/i18n'

export default {
    name: 'ProgressCol',
    props: {
        params: {
            default: () => ({}),
            type: Object,
            required: true
        },
        textClass: {
            default: '',
            type: String
        }
    },
    setup(props) {
        const { t } = i18n().global
        const { status } = props.params;
        const statusText = {
            'in_progress': t('pages.inventory_ingestion_hub.dashboard.table_status.in_progress'),
            'error': t('pages.inventory_ingestion_hub.dashboard.table_status.error'),
            'success': t('pages.inventory_ingestion_hub.dashboard.table_status.success'),
            'processing': t('pages.inventory_ingestion_hub.dashboard.table_status.processing'),
            'saved': t('pages.inventory_ingestion_hub.dashboard.table_status.saved'),
            'noFontFiles': t('pages.inventory_ingestion_hub.dashboard.table_status.noFontFiles'),
        }[status];

        const statusTooltipDesc = {
            'in_progress': t('pages.inventory_ingestion_hub.dashboard.tooltip_status.in_progress'),
            'error': t('pages.inventory_ingestion_hub.dashboard.tooltip_status.error'),
            'success': t('pages.inventory_ingestion_hub.dashboard.tooltip_status.success'),
            'processing': t('pages.inventory_ingestion_hub.dashboard.tooltip_status.processing'),
            'saved': t('pages.inventory_ingestion_hub.dashboard.tooltip_status.saved'),
            'noFontFiles': t('pages.inventory_ingestion_hub.dashboard.tooltip_status.noFontFiles'),
        }[status];

        return {
            status,
            statusText,
            statusTooltipDesc
        };
    }
}
</script>

<style lang="scss">
.bulk-ingestion-progress-state {
    display: inline-flex;
    align-items: center;

    &__color-dot {
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 50%;
        display: inline-block;
        margin-right: 0.5rem;
    }

    &__color-dot--success {
        background: var(--md-color--turtle-green);
    }

    &__color-dot--error {
        background: var(--md-color--red-babe--500);
    }

    &__color-dot--in_progress {
        background: var(--md-color--spirits);
    }

    &__color-dot--processing {
        background: var(--md-color--taco-yellow);
    }

    &__color-dot--saved {
        background: var(--md-color--turtle-green);
    }

    &__color-dot--noFontFiles {
        background: var(--md-color--spirits--500);
    }
}
</style>